import appNavItemTypeCheckers from '../../types/appNavItemTypeCheckers';

const getDashboardIdsInApp = ({ app }: { app: V3.App }) => {
  try {
    return app.navigationSettings.sections.reduce((acc, section) => {
      const sectionIds = section.items.reduce((itemAcc, item) => {
        if (appNavItemTypeCheckers.isDashboard(item)) {
          return [...itemAcc, item.dashboardId];
        }
        if (appNavItemTypeCheckers.isDashboardsIndex(item)) {
          return [...itemAcc, ...item.dashboardIds];
        }
        if (appNavItemTypeCheckers.isAllAssets(item)) {
          return [...itemAcc, ...item.dashboards.map((d) => d.id)];
        }
        return itemAcc;
      }, [] as string[]);

      return [...acc, ...sectionIds];
    }, [] as string[]);
  } catch (e) {
    return [];
  }
};

export default getDashboardIdsInApp;
